import { z } from 'zod';

export const InsurancePlanQuoteContextSchema = z.object({
  internal_id: z.string().max(128),
  name: z.string().max(3000),
  carrier: z.string().max(3000),
  product: z.enum(['medicare_advantage', 'medicare_supplement']),
  type: z.string().max(128),
  metal_level: z.enum(['bronze', 'silver', 'gold', 'platinum']).nullable(),
  rating: z.number().int().min(0).max(5).nullable(),
});

export type InsurancePlanQuoteContextEntity = z.infer<
  typeof InsurancePlanQuoteContextSchema
>;
